module.exports = __webpack_public_path__ + "img/P19.09653524.png";